import dayjs from 'dayjs'
import {EB} from './bus'

export function check_channel(channel) {
  if (!channel) {
    return false
  }

  const pack = JSON.parse(localStorage.getItem('pack'))
  if (typeof channel === 'string' && pack.extend_package.some(i => i.channel === channel)) {
    const extent_package = pack && pack.extend_package ? pack.extend_package.find(i => i.channel === channel) : null
    return dayjs().isBefore(dayjs(new Date(extent_package.license_to)), 's');
  } else if (typeof channel === 'object' && pack.extend_package.some(i => channel.includes(i.channel))) {
    const extent_package_list = pack.extend_package.filter(i => channel.includes(i.channel))
    for (const extent_package of extent_package_list) {
      if (dayjs().isBefore(dayjs(new Date(extent_package.license_to)), 's')) {
        return true
      }
    }
    return false
  } else {
    return false
  }
}

export function check_feature(feature, channel = 'shopee_marketing') {
  if (!feature || !channel) {
    return false
  }

  const pack = JSON.parse(localStorage.getItem('pack'))
  const extent_package = pack && pack.extend_package ? pack.extend_package.find(i => i.channel === channel) : null
  if (extent_package) {
    if (extent_package.package.extra_data && extent_package.package.extra_data.marketing &&
      extent_package.package.extra_data.marketing[feature]) {
      return dayjs().isBefore(dayjs(new Date(extent_package.license_to)), 's');
    } else {
      return false
    }
  } else {
    return false
  }
}

export function check_shop_connect_gte(number = 1, channel = 'shopee_marketing') {
  if (!number) {
    return false
  }

  const pack = JSON.parse(localStorage.getItem('pack'))
  const extent_package = pack && pack.extend_package ? pack.extend_package.find(i => i.channel === channel) : null
  return !!(extent_package && extent_package.package && extent_package.package.shop_connect >= number)
}

export function show_expr_notification() {
  // EB.$emit('CFM_warning', 'Quý khách cần áp dụng gói để sử dụng tính năng này.')
  EB.$emit('CFM_warning', 'Gói sản phẩm của quý khách không có tính năng hiện tại hoặc đã hết hạn. Vui lòng gia hạn để không bị gián đoạn trong quá trình sử dụng.')
}



// WEBPACK FOOTER //
// ./src/addon/check_license.js